export default __webpack_public_path__ + "static/media/oxedin_person_recortado.679f6c68.png";